/**
 * Asset selector - base module
 */
goog.provide('yext.dam.assetselector');

goog.require('yext');
goog.require('yext.dam.assetselector.events');
goog.require('yext.dam.assetselector.loader');
goog.require('yext.dam.assetselector.search');
goog.require('yext.dam.assetselector.selector');
goog.require('yext.dam.assetselector.video');
goog.require('yext.image.Photocrop');
goog.require('yext.imageloader');
goog.require('yext.notify');

yext.dam.assetselector.has = {};

/**
 * Initialize asset selector module
 */
yext.dam.assetselector.init = function(params) {
  // prevent dam from being initialized more than once on a page
  if (yext.dam.assetselector.has.init) {
    return;
  } else {
    yext.dam.assetselector.has.init = true;
  }

  yext.dam.assetselector.assetType = '';
  yext.dam.assetselector.localeCode = $('.js-location-info').data('locale-code') || $('.js-entity-info').data('locale-code');

  var $s = $('.js-asset-selector');
  yext.dam.assetselector.$selector = $s;
  yext.dam.assetselector.$addAsset = $s.find('.js-add-asset');
  yext.dam.assetselector.$tabControl = $s.find('.js-asset-selector-tabs');
  yext.dam.assetselector.$tabs = $s.find('.js-asset-selector-tab');
  yext.dam.assetselector.$panel = $s.find('.js-asset-selector-panel');
  yext.dam.assetselector.$preview = $s.find('.js-asset-selector-preview');

  // photos
  yext.dam.assetselector.$uploadImage = $s.find('.js-upload-image');
  yext.dam.assetselector.$uploadImageTab = $s.find('.js-upload-image-tab');
  yext.dam.assetselector.$photoContent = $s.find('.js-asset-photo');

  // videos
  yext.dam.assetselector.$enterYoutube = $s.find('.js-enter-video');
  yext.dam.assetselector.$searchYoutube = $s.find('.js-search-video');
  yext.dam.assetselector.$enterYoutubeTab = $s.find('.js-enter-video-tab');
  yext.dam.assetselector.$searchYoutubeTab = $s.find('.js-search-video-tab');
  yext.dam.assetselector.$videoContent = $s.find('.js-asset-video');

  yext.dam.assetselector.$videoAddAssetButton = $s.find('.js-select-asset-buttons .js-add-asset');

  // asset
  yext.dam.assetselector.$selectFromLibraryTab = $s.find('.js-select-from-library-tab');
  yext.dam.assetselector.$selectFromLibrary = $s.find('.js-select-from-library');

  // Type safety
  if (typeof params != 'object') {
    params = {};
  }

  yext.dam.assetselector.selector.init($s);
  $(yext.dam.assetselector.selector).on('selected.assetselector', yext.dam.assetselector.assetSelected);
  yext.dam.assetselector.search.init(
    $s,
    yext.dam.assetselector.searchSuccess,
    yext.dam.assetselector.searchError,
    params.locationSearchParam);
  params = $.extend(params, {
    localeCode: yext.dam.assetselector.localeCode,
  });
  yext.dam.assetselector.search.setParams(params);

  yext.dam.assetselector.loader.init(params.alwaysUploadPhoto);
  yext.dam.assetselector.video.init();
  $(yext.dam.assetselector.loader).on('loaded.assetselector', yext.dam.assetselector.assetLoaded);

  yext.dam.assetselector.getPermissions();
  yext.dam.assetselector.bindings();

  // init photocropping
  var photocropDefaults = {
    $buttons: yext.dam.assetselector.$selector.find('.js-crop-buttons'),
    $container: $('.js-photo-crop-wrap'),
  };
  var photocropOptions = $.extend({}, photocropDefaults, params);
  yext.dam.assetselector.photocrop = new yext.image.Photocrop(photocropOptions);


  $(yext.dam.assetselector.events).on(yext.dam.assetselector.events.showSelector, function() {
    // Pass all arguments, except for the event, to the normal show method
    var remainingArgs = Array.prototype.slice.call(arguments, 1);
    yext.dam.assetselector.show(...remainingArgs);
  });
  $(yext.dam.assetselector.events).on(yext.dam.assetselector.events.closeSelector, yext.dam.assetselector.close);
  $(yext.dam.assetselector.events).on(yext.dam.assetselector.events.resetTitleSelector, yext.dam.assetselector.resetTitle);
};

/**
 * Get permissions from DOM
 */
yext.dam.assetselector.getPermissions = function() {
  yext.dam.assetselector.has.DAM = !!yext.dam.assetselector.$selector.data('dam-enabled');
};

/**
 * Show/hide image loader
 *
 * @param {boolean} show True to show, false to hide
 */
yext.dam.assetselector.toggleLoader = function(show) {
  yext.dam.assetselector.$selector.find('.js-assets-loading').toggle(show);
};

/**
 * Configure the dialog that will contain the asset selector
 *
 * @param {string} dialog type: text | photo | video | custom
 * @param {string} fieldName: field name to render in custom asset selector title
 * TODO(mattjs) Figure out why this needs to be recreated each time
 */
yext.dam.assetselector.dialog = function(type, fieldName) {
  var dialogTitle; var minWidth;
  if (type == yext.dam.assetselector.types.PHOTO) {
    dialogTitle = yext.msgc('dam', 'Add Photo');
    minWidth = '770';
  } else if (type == yext.dam.assetselector.types.TEXT) {
    dialogTitle = yext.msgc('dam', 'Use a Text Asset');
    minWidth = '685';
  } else if (type == yext.dam.assetselector.types.VIDEO) {
    dialogTitle = yext.msgc('dam', 'Add Video');
    minWidth = '835';
  } else if (type == yext.dam.assetselector.types.CUSTOM) {
    dialogTitle = yext.msgc('dam', 'Use a {0} Asset', fieldName);
    minWidth = '800';
  }

  yext.dam.assetselector.$selector.dialog({
    autoOpen: true,
    dialogClass: 'asset-selector-dialog',
    modal: true,
    draggable: false,
    resizable: false,
    minWidth: minWidth,
    title: dialogTitle,
    close: yext.dam.assetselector.close,
  });
};

/**
 * Called when the asset selector is closed
 */
yext.dam.assetselector.close = function() {
  if (yext.dam.assetselector.$selector.data('ui-dialog')) {
    yext.dam.assetselector.$selector.dialog('destroy');
  }
  yext.dam.assetselector.selector.reset();
  yext.dam.assetselector.video.clearPreview();
  yext.dam.assetselector.loader.reset();
  yext.dam.assetselector.search.reset();
  if (yext.dam.assetselector.photocrop) {
    yext.dam.assetselector.photocrop.reset();
    yext.dam.assetselector.resetCropState();
    yext.dam.assetselector.toggleAssetSelectorButtons(false);
  }
  yext.dam.assetselector.disableAdd();
  yext.dam.assetselector.showSelectFromLibrary();
  yext.dam.assetselector.selector.$photoPreviewMessage.show();
  yext.dam.assetselector.selector.$photoPreview.hide();
  $(yext.dam.assetselector.events).trigger('closed.assetselector');
  $(yext.dam.assetselector.events).off('added.assetselector');
};

/**
 * Show an asset selector with asset of type
 *
 * @param {!Object} params for the search endpoint (including usage)
 * @param {string} fieldName The name of the field that opened the selector
 * @param {number} customFieldId The id of the custom field associated with the asset
 * @param {!Object} constraints The constraints necessary on selecting a photo
 */
yext.dam.assetselector.show = function(params, fieldName, customFieldId, constraints) {
  var type = params.type;
  yext.dam.assetselector.selector.setType(type);
  yext.dam.assetselector.assetType = type;
  yext.dam.assetselector.constraints = constraints;
  params = $.extend(params, {
    customFieldId: customFieldId,
  });

  params = $.extend(params, constraints);

  yext.dam.assetselector.search.setParams(params);
  $('.image-disclaimer').show();

  // Name of the field to which the selector is currently bound
  yext.dam.assetselector.fieldName = fieldName;

  // The business logo field allows the user to crop outside of the image so the
  // entire logo can be contained in the 1:1 crop.
  if (fieldName === 'location.business_logo' || fieldName === 'location.headshot') {
    yext.dam.assetselector.photocrop.setViewMode(0);
    yext.dam.assetselector.photocrop.setFillColor('#ffffff');
  } else {
    // Use default view mode
    yext.dam.assetselector.photocrop.setViewMode();
  }

  // Id of the custom field to which the selector is currently bound
  yext.dam.assetselector.customFieldId = customFieldId;

  // Set asset selector's type
  yext.dam.assetselector.$selector.data('type', type);

  // always show selector buttons
  yext.dam.assetselector.toggleAssetSelectorButtons(true);

  // perform open action
  if (params.hideEnterImageUrl) {
    yext.imageloader.hideUrlOption();
  } else {
    yext.imageloader.showUrlOption();
  }

  // if there on constraints, show them
  if (constraints) {
    yext.imageloader.updateOptions({
      'constraints': constraints,
    });
  }

  // DAM not enabled
  if (type !== yext.dam.assetselector.types.TEXT && !yext.dam.assetselector.has.DAM) {
    yext.dam.assetselector.showLoaderOnly(type);
    return;
  }

  // Hide the "Upload New Photo" tab for users with use asset for permissions
  if (params.hideUploadImageTab) {
    yext.dam.assetselector.$uploadImageTab.hide();
  } else {
    yext.dam.assetselector.$uploadImageTab.show();
  }

  if (params.hideNonAssetVideoTabs) {
    yext.dam.assetselector.$enterYoutubeTab.hide();
    yext.dam.assetselector.$searchYoutubeTab.hide();
  } else {
    yext.dam.assetselector.$enterYoutubeTab.show();
    yext.dam.assetselector.$searchYoutubeTab.show();
  }

  // Only set up search and labels drop down if the account has DAM enabled
  yext.dam.assetselector.search.searchableList();
  yext.dam.assetselector.search.make();

  var searchPlaceHolder;
  if (type == yext.dam.assetselector.types.PHOTO) {
    searchPlaceHolder = yext.msgc('dam', 'Search for a Photo');
  } else if (type == yext.dam.assetselector.types.TEXT) {
    searchPlaceHolder = yext.msgc('dam', 'Search for a Text Asset');
  } else if (type == yext.dam.assetselector.types.VIDEO) {
    searchPlaceHolder = yext.msgc('dam', 'Search for a Video');
  }

  yext.dam.assetselector.$tabControl.toggle(type !== yext.dam.assetselector.types.TEXT);
  yext.dam.assetselector.$videoContent.toggle(type === yext.dam.assetselector.types.VIDEO);
  yext.dam.assetselector.$photoContent.toggle(type === yext.dam.assetselector.types.PHOTO);
  yext.dam.assetselector.$selector
    .find('.js-library-search-text')
    .prop('placeholder', searchPlaceHolder);
  yext.dam.assetselector.dialog(type, fieldName);

  yext.dam.assetselector.updateAssetAddButtonText(params.isSuggestedEditMode, params.isFutureEditMode, type);
};

/**
 * Call this to change asset 'Add' button text to depending on whether it is on suggest edit mode
 *
 * @param {boolean} isSuggestedEditMode Whether it is in suggest edit mode
 * @param {boolean} isFutureEditMode  Whether it is a scheduled update
 */
yext.dam.assetselector.updateAssetAddButtonText = function(isSuggestedEditMode, isFutureEditMode, type) {
  var addButton = yext.msg('Add');
  var uploadButton = yext.msg('Upload');
  var cropButton = yext.msg('Crop');
  var buttonToUse;

  buttonToUse = addButton;
  if (type === yext.dam.assetselector.types.PHOTO) {
    buttonToUse = cropButton;
  }

  if (isSuggestedEditMode) {
    if (yext.dam.assetselector.assetType === 'VIDEO') {
      buttonToUse = yext.msg('Request Approval');
    } else if (yext.dam.assetselector.assetType === 'PHOTO') {
      uploadButton = yext.msg('Request Upload');
      buttonToUse = uploadButton;
    }
  } else if (isFutureEditMode) {
    if (yext.dam.assetselector.assetType === 'VIDEO') {
      addButton = yext.msg('Schedule Update');
      buttonToUse = addButton;
    } else if (yext.dam.assetselector.assetType === 'PHOTO') {
      uploadButton = yext.msg('Schedule Upload');
      buttonToUse = uploadButton;
    }
  }

  yext.dam.assetselector.$selector.find('.js-add-asset span').text(buttonToUse);
  yext.dam.assetselector.$selector.find('.js-crop-upload span').text(buttonToUse);
};

/**
 * Call this to show the image uploader only
 *
 * @param {string} type They loader type (photo/video)
 */
yext.dam.assetselector.showLoaderOnly = function(type) {
  if (type === yext.dam.assetselector.types.PHOTO) {
    yext.dam.assetselector.$tabControl.hide();
    yext.dam.assetselector.showUploadPhoto();
    yext.dam.assetselector.dialog(type);
    yext.dam.assetselector.toggleAssetSelectorButtons(false);
  } else if (type === yext.dam.assetselector.types.VIDEO) {
    // handle tabs
    yext.dam.assetselector.$tabControl.show();
    yext.dam.assetselector.$tabControl.find('.js-asset-video').show();
    yext.dam.assetselector.$tabControl.find('.js-asset-photo').hide();
    // handle preview
    yext.dam.assetselector.$preview.show();
    yext.dam.assetselector.showEnterYoutube();
    yext.dam.assetselector.dialog(type);
  }
};

/**
 * Callback for a successful search
 *
 * @param {!Object} response The response from the search
 * @param {boolean} append When scrolling to receive more matches for a
 * particular search this will be true and will the append to the existing
 * list of assets. Otherwise the assets will be cleared for the new search
 */
yext.dam.assetselector.searchSuccess = function(response, append) {
  if (!append) {
    $(yext.dam.assetselector.search).trigger('newSearch.assetselector');
  }
  yext.dam.assetselector.toggleLoader(false);
  yext.dam.assetselector.$selector.find('.js-no-search-results').toggle(!response.assets.length && !append);

  if (response.preview) {
    yext.dam.assetselector.selector.$customPreviewContent = $(response.preview);
  }

  for (var i = 0; i < response.assets.length; i++) {
    var asset = response.assets[i];
    yext.dam.assetselector.selector.create(asset);
  }
  if (response.assets.length == 1 && !append) {
    yext.dam.assetselector.selector.selectAsset(yext.dam.assetselector.selector.$assetList.find('.js-asset-thumbnail'));
  }
};

/**
 * Called when the search endpoint errors out
 *
 * @param {!Object} XMLHttpRequest error object
 */
yext.dam.assetselector.searchError = function(xhr) {
  var message = yext.msg('There was a problem connecting to the server. Please <a href="{0}">reload</a> or try again.', document.location.href);
  if (xhr.responseJSON && yext.isString(xhr.responseJSON.error)) {
    message = xhr.responseJSON.error;
  }
  yext.notify.showError(message);
};

/**
 * Triggered when an asset is selected
 */
yext.dam.assetselector.assetSelected = function() {
  yext.dam.assetselector.$addAsset.prop('disabled', false);
};

yext.dam.assetselector.showLoadingOverlay = function() {
  $('.js-selector-loading-overlay').show();
};

yext.dam.assetselector.removeLoadingOverlay = function() {
  $('.js-selector-loading-overlay').fadeOut();
};

yext.dam.assetselector.assetLoaded = function(e) {
  // show the loading screen
  yext.dam.assetselector.showLoadingOverlay();
  yext.dam.assetselector.photocrop.initView(
    yext.dam.assetselector.loader.loaded,
    yext.dam.assetselector.constraints,
  );
  // set the dialog as crop state
  yext.dam.assetselector.selector.setCropState();
  // when the user binds the cropped photo, trigger event
  $(document).bind('photocrop.cropped', function(e, croppedImage, sourceUrl) {
    if (yext.dam.assetselector.loader.loaded) {
      yext.dam.assetselector.loader.loaded.croppedImage = croppedImage;
      yext.dam.assetselector.loader.loaded.sourceUrl = sourceUrl;
    }
    yext.dam.assetselector.add(yext.dam.assetselector.loader.loaded);
    yext.dam.assetselector.resetCropState();
    yext.dam.assetselector.toggleAssetSelectorButtons(false);
  });

  // when the user binds the cropped photo, trigger event
  $(document).bind('photocrop.failed', function(e, data) {
    var message = yext.msg('Image crop failed. Please try again');

    if (data && data.error) {
      message = data.error;
    }

    yext.dam.assetselector.photocrop.reset();
    yext.dam.assetselector.resetCropState();
    yext.dam.assetselector.toggleAssetSelectorButtons(false);

    yext.imageloader.$photoErrors
      .html(message)
      .show();
  });
  $(document).bind('photocrop.discarded', function(e, croppedImage) {
    yext.dam.assetselector.resetCropState();
    yext.dam.assetselector.toggleAssetSelectorButtons(false);
  });

  $(document).bind('photocrop.init', function(e, croppedImage) {
    yext.dam.assetselector.removeLoadingOverlay();
  });
  // address bug in older versions in jQuery around custom events on objects
  e.preventDefault();
};

/**
 * Triggers a recenter of the container dialog's position
 */
yext.dam.assetselector.recenterSelector = function() {
  yext.dam.assetselector.$selector.dialog({
    position: {my: 'center', at: 'center', of: window}, // This is the default value of position
  });
};

/**
 * Bind switching between tabs and the cancel button
 */
yext.dam.assetselector.bindings = function() {
  yext.dam.assetselector.$uploadImageTab.click(function() {
    yext.dam.assetselector.selector.$assetDetails.hide();
    yext.dam.assetselector.showUploadPhoto();
    yext.dam.assetselector.recenterSelector();
  });

  yext.dam.assetselector.$enterYoutubeTab.click(function() {
    yext.dam.assetselector.showEnterYoutube();
    yext.dam.assetselector.recenterSelector();
  });

  yext.dam.assetselector.$searchYoutubeTab.click(function() {
    yext.dam.assetselector.showSearchYoutube();
    yext.dam.assetselector.recenterSelector();
  });

  yext.dam.assetselector.$selectFromLibraryTab.click(function() {
    if (yext.dam.assetselector.photocrop) {
      yext.dam.assetselector.photocrop.reset();
      yext.dam.assetselector.resetCropState();
      yext.dam.assetselector.toggleAssetSelectorButtons(false);
    }
    yext.dam.assetselector.showSelectFromLibrary();

    yext.dam.assetselector.search.focusOnInputBox();
    yext.dam.assetselector.selector.resetPreview();
    yext.dam.assetselector.recenterSelector();
  });

  yext.dam.assetselector.$selector.find('.js-cancel-selection').click(function() {
    yext.dam.assetselector.close();
  });

  yext.dam.assetselector.$selector.find('.js-add-asset').click(function() {
    // Photo assets are sent to the cropper
    if (yext.dam.assetselector.selector.selected.type == 'Photo') {
      // Send asset into cropper
      yext.dam.assetselector.photocrop.initView(
        yext.dam.assetselector.selector.selected,
        yext.dam.assetselector.constraints,
      );
      // set the dialog as crop state
      yext.dam.assetselector.selector.setCropState();
      yext.dam.assetselector.showLoadingOverlay();

      // Navigate to cropper tab
      yext.dam.assetselector.$uploadImageTab.click();

      // Hide disclaimer when cropping approved assets
      $('.image-disclaimer').hide();

      // Bind cropped asset upload button
      $(document).bind('photocrop.cropped', function(e, croppedImage, sourceUrl) {
        yext.dam.assetselector.selector.selected.croppedImage = croppedImage;
        yext.dam.assetselector.selector.selected.sourceUrl = sourceUrl;
        yext.dam.assetselector.add(yext.dam.assetselector.selector.selected);

        yext.dam.assetselector.resetCropState();
        // Show disclaimer after finished with approved asset
        $('.image-disclaimer').show();
        yext.dam.assetselector.toggleAssetSelectorButtons(false);
      });

      // Bind crop failed
      $(document).bind('photocrop.failed', function(e, data) {
        var message = yext.msg('Image crop failed. Please try again');

        if (data && data.error) {
          message = data.error;
        }

        yext.dam.assetselector.photocrop.reset();
        yext.dam.assetselector.resetCropState();
        // Show disclaimer after finished with approved asset
        $('.image-disclaimer').show();
        yext.dam.assetselector.toggleAssetSelectorButtons(false);

        yext.imageloader.$photoErrors
          .html(message)
          .show();
      });

      // Bind crop discarded
      $(document).bind('photocrop.discarded', function(e, croppedImage) {
        yext.dam.assetselector.resetCropState();
        // Show disclaimer after finished with approved asset
        $('.image-disclaimer').show();
        yext.dam.assetselector.toggleAssetSelectorButtons(false);
      });

      // Bind photo initialized in cropper
      $(document).bind('photocrop.init', function(e, croppedImage) {
        yext.dam.assetselector.removeLoadingOverlay();
      });
    } else {
      yext.dam.assetselector.add(yext.dam.assetselector.selector.selected);
    }
  });

  // Triggered by a non appending search
  $(yext.dam.assetselector.search).on('newSearch.assetselector', function() {
    yext.dam.assetselector.disableAdd();
    yext.dam.assetselector.toggleLoader(true);
    yext.dam.assetselector.selector.reset();
  });
};

/**
 * Shows the image upload panel
 */
yext.dam.assetselector.showUploadPhoto = function() {
  if (yext.dam.assetselector.$uploadImageTab.hasClass('selected')) {
    return;
  }

  yext.dam.assetselector.$tabs.removeClass('selected');
  yext.dam.assetselector.$uploadImageTab.addClass('selected');

  yext.dam.assetselector.$panel.hide();
  yext.dam.assetselector.$uploadImage.show();
  yext.dam.assetselector.$preview.hide();
  yext.dam.assetselector.toggleAssetSelectorButtons(false);

  yext.dam.assetselector.$addAsset.prop('disabled', true);
};

/**
 * @param {boolean} show buttons?
 */
yext.dam.assetselector.toggleAssetSelectorButtons = function(show) {
  yext.dam.assetselector.$selector.find('.js-select-asset-buttons').toggle(show);
};

/**
 * Shows the enter youtube panel
 */
yext.dam.assetselector.showEnterYoutube = function() {
  if (yext.dam.assetselector.$enterYoutubeTab.hasClass('selected')) {
    return;
  }

  yext.dam.assetselector.selector.selected = undefined;
  yext.dam.assetselector.$tabs.removeClass('selected');
  yext.dam.assetselector.$enterYoutubeTab.addClass('selected');

  yext.dam.assetselector.$panel.hide();
  yext.dam.assetselector.$enterYoutube.find('input').val('');
  yext.dam.assetselector.$videoAddAssetButton.show();
  yext.dam.assetselector.$enterYoutube.show();

  yext.dam.assetselector.$addAsset.prop('disabled', true);
  yext.dam.assetselector.video.clearPreview();
};

/**
 * Shows the search youtube panel
 */
yext.dam.assetselector.showSearchYoutube = function() {
  if (yext.dam.assetselector.$searchYoutubeTab.hasClass('selected')) {
    return;
  }

  yext.dam.assetselector.selector.selected = undefined;
  yext.dam.assetselector.$tabs.removeClass('selected');
  yext.dam.assetselector.$searchYoutubeTab.addClass('selected');

  yext.dam.assetselector.$panel.hide();
  yext.dam.assetselector.$videoAddAssetButton.show();
  yext.dam.assetselector.$searchYoutube.show();
  yext.dam.assetselector.$searchYoutube.find('.js-select-video-button').removeClass('disabled');

  yext.dam.assetselector.$addAsset.prop('disabled', true);
  yext.dam.assetselector.video.clearPreview();
};

/**
 * Shows the select youtube from library panel
 */
yext.dam.assetselector.showSelectFromLibrary = function() {
  if (yext.dam.assetselector.$selectFromLibraryTab.hasClass('selected')) {
    return;
  }

  yext.dam.assetselector.selector.selected = undefined;
  yext.dam.assetselector.$tabs.removeClass('selected');
  yext.dam.assetselector.$selectFromLibraryTab.addClass('selected');

  yext.dam.assetselector.$panel.hide();
  yext.dam.assetselector.$videoAddAssetButton.show();
  yext.dam.assetselector.$selectFromLibrary.show();
  yext.dam.assetselector.$selectFromLibrary.find('.js-select-video-button').removeClass('disabled');
  yext.dam.assetselector.$preview.show();
  yext.dam.assetselector.toggleAssetSelectorButtons(true);

  yext.dam.assetselector.$addAsset.prop('disabled', true);
  yext.dam.assetselector.video.clearPreview();
};

/**
 * Broadcast when an asset has been chosen and close the dialog
 *
 * NOTE(mattjs) The logic is ordered this way on purpose. Added must trigger
 * before close
 *
 * @param {Asset} asset Selected asset object
 */
yext.dam.assetselector.add = function(asset) {
  $(yext.dam.assetselector.events).trigger('added.assetselector', asset);

  yext.dam.assetselector.$selector.dialog('close');
};

/**
 * Disable the add button
 */
yext.dam.assetselector.disableAdd = function() {
  yext.dam.assetselector.$addAsset.prop('disabled', true);
};

/**
 * removes the cropstate from dialog view
 */
yext.dam.assetselector.resetCropState = function() {
  // show the image loader
  yext.imageloader.$container.closest('.js-image-loader-wrap').show();
  yext.imageloader.updateOptions({
    'constraints': yext.dam.assetselector.constraints,
  });
  yext.dam.assetselector.selector.$context.removeClass('crop-state');
  yext.dam.assetselector.removeLoadingOverlay();
};

/**
 * resets the original title if present
 */
yext.dam.assetselector.resetTitle = function() {
  // reset the dialog title
  if (yext.dam.assetselector.selector.originalTitle) {
    yext.dam.assetselector.$selector.closest('.ui-dialog')
      .find('.ui-dialog-title')
      .text(yext.dam.assetselector.selector.originalTitle);
  }
  return false;
};

/**
 * resets the init state
 */
yext.dam.assetselector.resetInitState = function() {
  yext.dam.assetselector.has.init = false;
};

goog.exportSymbol('yext.dam.assetselector.show', yext.dam.assetselector.show);
goog.exportSymbol('yext.dam.assetselector.init', yext.dam.assetselector.init);
goog.exportSymbol('yext.dam.assetselector.has.DAM', yext.dam.assetselector.has.DAM);
goog.exportSymbol('yext.dam.assetselector.showLoaderOnly', yext.dam.assetselector.showLoaderOnly);
goog.exportSymbol('yext.dam.assetselector.types.PHOTO', yext.dam.assetselector.types.PHOTO);
goog.exportSymbol('yext.dam.assetselector.resetInitState', yext.dam.assetselector.resetInitState);
